// extracted by mini-css-extract-plugin
export default {"link":"link__z6Nez","underline":"underline__rf5aG"};